import { GET_SETTINGS } from "../constants";

export const settingsDetails = (
    state = {
        settingList:[],
    }, action
) => {
    switch (action.type){
        case GET_SETTINGS: 
         return { ...state, settingList: action.settingList };
         default:
      return state;
    }
}